import { RootState } from '@app/redux/root-reducer';

export const selectAddCompensationState = (store: RootState) =>
  store.documentsReducer.addCompensation;
export const selectAddOfferLetterState = (store: RootState) =>
  store.documentsReducer.addOfferLetter;
